import { render, staticRenderFns } from "./PurchaseOrdersCollection.vue?vue&type=template&id=04571692&"
import script from "./PurchaseOrdersCollection.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports